import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

import styles from './EndPages.module.scss';
import { FIND_BRANCH_BUTTON_TEXT } from './constants';

const PAGE_TITLE = 'Thank you for your interest.';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Unfortunately, we are unable to locate a prescreened offer of credit that was sent to you. If
    you are interested in applying for a loan, please call or visit a branch near you. One of our
    knowledgeable and helpful team members will be happy to help you.
  </p>
);

const NoPreScreenedOfferFoundPage = () => {
  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
      <a
        className={styles.findBranchLink}
        href={envs[EnvironmentVariable.FindBranchLink]}
        rel="noopener noreferrer"
      >
        <Button kind="primary" size="form">
          {FIND_BRANCH_BUTTON_TEXT}
        </Button>
      </a>
    </>
  );
};

export default NoPreScreenedOfferFoundPage;
